import {
  AspectRatio,
  Flex,
  SimpleGrid,
  Skeleton,
  SkeletonProps,
  Stack,
} from '@chakra-ui/react';

const NUM_CARDS = 9;

const skeletonColors: Partial<SkeletonProps> = {
  startColor: 'blackAlpha.50',
  endColor: 'blackAlpha.100',
};

const ProductCardSkeleton = () => (
  <Flex
    overflow="hidden"
    flexDirection="column"
    flexGrow={{ base: 0, sm: 1 }}
    justifyContent="flex-start"
    gap="1"
    minW="300px"
  >
    <AspectRatio ratio={1 / 1.2}>
      <Skeleton borderRadius="4px" {...skeletonColors} />
    </AspectRatio>

    <Stack
      spacing="2.5"
      pt={1}
      pb={3}
      justifyContent="flex-start"
      borderBottomWidth="1px"
      borderBottomColor="blackAlpha.500"
    >
      <Skeleton height="20px" width="70%" {...skeletonColors} />
      <Skeleton height="14px" width="90%" {...skeletonColors} />
      <Skeleton height="14px" width="60%" {...skeletonColors} />
      <Skeleton height="14px" width="40%" {...skeletonColors} />
      <Skeleton height="14px" width="50%" mt="14px" {...skeletonColors} />
    </Stack>
  </Flex>
);

export const RelatedHomesSkeletonLoadingGrid = () => (
  <SimpleGrid
    columns={{ mobile: 1, tablet: 2, desktop: 3 }}
    rowGap="10"
    columnGap="5"
  >
    {[...Array(NUM_CARDS)].map((_, index) => (
      <ProductCardSkeleton key={`skeleton-${index}`} />
    ))}
  </SimpleGrid>
);
